<template>
  <div class="main" :key="addKey">
    <page-head></page-head>
    <div class="headH" :style="{height: headHeight}"></div>
    <router-view></router-view>
    <main-footer></main-footer>
  </div>
</template>
<script>
import pageHead from "./page-head";
import { getMenu } from "@/api/index";
export default {
  components: {
    pageHead
  },
  data() {
    return {
      addKey: 0,
      menuList: [],
      headHeight: "135px"
    };
  },
  watch: {
    $route: function() {
      if (this.$route.query && this.$route.query.vid) {
        return false;
      } else {
        location.reload();
      }
    }
  },
  created() {
    if (!localStorage.bwsteelMenus) {
      this.getMenuFun();
    } else {
      let menus = JSON.parse(localStorage.bwsteelMenus);
      this.$set(this.$data, "menuList", menus);
    }
  },
  mounted() {
    this.getHeight();
  },
  methods: {
    getMenuFun() {
      getMenu().then(res => {
        if (res.data.code === 1000) {
          let datas = res.data.data[0].childs.map(item => {
            if (item.childs) {
              item.hasChilds = true;
            }
            item.path = this.$utils.getPathByNodeIndexName(
              item.nodeIndexName
            ).url;
            item.pathName = this.$utils.getPathByNodeIndexName(
              item.nodeIndexName
            ).name;
            return item;
          });
          localStorage.setItem("bwsteelMenus", JSON.stringify(datas));
          this.$set(this.$data, "menuList", datas);
          this.addKey++;
        } else {
          this.$message.error("栏目获取失败！");
        }
      });
    },
    getHeight() {
      let flag = this.$utils.isMobile();

      if (document.querySelector(".head")) {
        let dom = document.querySelector(".head");
        if (flag) {
          this.headHeight = dom.offsetHeight + "px";
        } else {
          this.headHeight = "135px";
        }
      }
    }
  }
};
</script>